import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient, withFetch,
  withInterceptors,
  withInterceptorsFromDi
} from "@angular/common/http";
import {HttpLoaderFactory} from "./shared/shared.module";
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalGuardConfiguration,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalModule, MsalService
} from "@azure/msal-angular";
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication
} from "@azure/msal-browser";
import {environment} from "../environments/environment";
import {LoadingBarModule} from "@ngx-loading-bar/core";
import {LoadingBarRouterModule} from "@ngx-loading-bar/router";
import {AuthenticationInterceptor} from "./interceptors/authentication.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes), provideHttpClient(withInterceptorsFromDi(), withFetch()), importProvidersFrom(
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      defaultLanguage: 'en',
    })),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    LoadingBarRouterModule,
    LoadingBarModule,
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ],
};

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(
    { // MSAL Configuration
      auth: {
        clientId: environment.msal.clientId,
        authority: environment.msal.tenantId,
        redirectUri: environment.msal.redirectUri,
        navigateToLoginRequestUrl: true,
      },
      cache: {
        cacheLocation : BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: false,
      },
      system: {
        loggerOptions: {
          piiLoggingEnabled: false
        }
      }
    }
  );
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(`${environment.api}/*`, [`${environment.msal.clientId}/.default`]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [`${environment.msal.clientId}/.default`]
    },
    loginFailedRoute: '/login'
  };
}
